<template>
  <div>
    <div class="con-tab-ejemplo">
      <div class="vx-row">
        <div class="vx-col w-full vx-coll-fixed-hight text-center">
          <vs-table :data="loanDetails">
            <template slot="thead">
              <vs-th class="w-1/12"><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableLoanDetail.no') }}</span></vs-th>
              <vs-th class="w-4/12"><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableLoanDetail.type') }}</span></vs-th>
              <vs-th class="w-4/12"><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableLoanDetail.date') }}</span></vs-th>
              <vs-th class="w-6/12"><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableLoanDetail.amount') }}</span></vs-th>
              <vs-th class="w-1/12"></vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(res, index) in data" :state="isAdjustmentState(res)">
                <vs-td :data="(index+1)">
                  {{ (index+1) }}
                </vs-td>
                <vs-td :data="res.loanDetailType">
                  {{ res.loanDetailType | loanDetailType }}
                </vs-td>
                <vs-td :data="res.loanDate">
                  {{ res.loanDate | convYYYYMMDDToDDMMYYYY }}
                </vs-td>
                <vs-td :data="res.amount">
                  {{ res.amount | numberFormat}}
                  <small v-if="(res.adjustment)"><u>{{ $t('sections.accounting.dataForm.adjustment') }}</u></small>
                </vs-td>
                <vs-td>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-delete" @click="delLoanDetail(res.id)" v-show="!isHideDelLoanDetail(res)"></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');

export default {
  props: ['manage'],
  computed:{
    ...mapAccountingState([
      'status',
      'contract',
      'loanDetails',
    ])
  },
  methods: {
    ...mapAccountingActions([
      'deleteLoanDetail',
    ]),
    isHideDelLoanDetail (res){
      if(!res.transaction && res.seq > 1  && this.manage ) return false
      return true
    },
    isAdjustmentState(res){
      let isState = null
      if(res.adjustment){
        isState = "warning"
      }
      return isState
    },
    async delLoanDetail (id) {
      this.actionID = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('notification.confirm-delete-title'),
        text: this.$t('notification.confirm-delete-message'),
        accept: this.acceptDelLoanDetail
      })
    },
    async acceptDelLoanDetail () {
      await this.deleteLoanDetail({
        form: {
          id: this.actionID
        },
        vm: this
      })
    },
  },
}
</script>
<style scoped>
  .vx-coll-fixed-hight{
    display:block;
    width:100%;
    height:400px;
    overflow: auto;
  }
</style>
